module.exports = __webpack_public_path__ + "img/ysl.c8a57ad2.png";